/**
 * A param rather than a path segment, so opening a day is a shallow navigation
 * that leaves the calendar mounted underneath.
 */
export const CALENDAR_DAY_PARAM = 'day';

// Months loaded per batch: three on first render, three more each lazy-load.
export const CALENDAR_MONTHS_INITIAL = 3;

// No month holds more events than this.
export const CALENDAR_EVENTS_PER_MONTH = 100;

// Widens each month's fetch, so an event never falls between two windows.
export const CALENDAR_MONTH_PADDING_DAYS = 1;

// Records that can be exported. Each value is a path segment the API reads.
export const CALENDAR_KINDS = [
  'lineup-entry',
  'xp-session',
  'xp-artist',
] as const;

export type CalendarKind = (typeof CALENDAR_KINDS)[number];

export const CALENDAR_API_PATH = '/api/calendar';
